import './bootstrap'
import '../sass/app.scss'

document.addEventListener("DOMContentLoaded", () => {

    /////// BURGER MENU

    const burger = document.querySelector(".menu--burger");
    const menu = document.querySelector(".menu");
    const menuPages = document.querySelector(".menu--pages");
    var switchBurger = true;

    burger.addEventListener("click", function() {
        if (switchBurger == true) {
            menu.classList.toggle("active");
            burger.classList.toggle("active");
            setTimeout(function() {
                menuPages.classList.toggle("active");
            }, 500);
        } else {
            menuPages.classList.toggle("active");
            burger.classList.toggle("active");
            setTimeout(function() {
                menu.classList.toggle("active");
            }, 300);
        }
        switchBurger = !switchBurger;
    });

    /////// MOVING TOTEM

    var lastScrollTop = 0;

    const totem = document.querySelector("#totem");
    const scrollable = document.querySelectorAll(".scrollable");
    var scrollTotem = 0;

    scrollable.forEach(element => {
        // element should be replaced with the actual target element on which you have applied scroll, use window in case of no target element.
        element.addEventListener("scroll", function() { // or window.addEventListener("scroll"....
            var st = element.scrollTop; // Credits: "https://github.com/qeremy/so/blob/master/so.dom.js#L426"
            if (st > lastScrollTop) {
                scrollTotem++;
                totem.style.setProperty("transform", "rotate(" + scrollTotem + "deg)");
            } else {
                scrollTotem--;
                totem.style.setProperty("transform", "rotate(" + scrollTotem + "deg)");
            }
            lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
        }, false);

    });

    ///////// HOME MARQUEE

    const marquee = document.querySelector(".marquee");
    const marqueeContent = document.querySelector(".marquee-content");

    function marqueeLogos() {
        const logos = document.querySelectorAll(".home--partners--logos");
        var marqueeElementsDisplayed = 0;


        logos.forEach(element => {
            element.style.setProperty("--marquee-elements", marqueeContent.children.length);
            marqueeElementsDisplayed++;
        });

        marqueeContent.style.setProperty("--marquee-animation-duration", "" + (marqueeElementsDisplayed * 2) + "s");
        setTimeout(function() {
            marqueeContent.style.setProperty("--marquee-animation-duration", "" + 0 + "s");
            setTimeout(function() {
                marqueeContent.style.setProperty("--marquee-animation-duration", "" + (marqueeElementsDisplayed * 2) + "s");
            }, 200);
        }, 1000);
        marqueeContent.style.setProperty("--marquee-width", "-" + (marquee.scrollWidth) + "px");

        for (let i = 0; i < marqueeElementsDisplayed; i++) {
            marqueeContent.appendChild(marqueeContent.children[i].cloneNode(true));
        }
    }

    if (typeof(marquee) != 'undefined' && marquee != null) {
        marqueeLogos();

        // fix for browser others than chrome

        var intersectionObserver = new IntersectionObserver(function(entries) {
            if (entries[0].intersectionRatio > 0) {
                const marqueeStyle = marqueeContent.getAttribute('style');
                marqueeContent.setAttribute("style", "");
                setTimeout(function() {
                    marqueeContent.setAttribute("style", "" + marqueeStyle + "");
                }, 200);
            }
        });

        // début de l'observation
        intersectionObserver.observe(document.querySelector('.marquee-content'));
    }

    ///////// ARROW SWIPER

    const swipers = document.querySelectorAll(".swiper-container");

    swipers.forEach(element => {

        setTimeout(function() {
            const containerW = element.offsetWidth;
            const wrapperW = element.querySelector('.swiper-wrapper').offsetWidth;

            if (containerW > wrapperW) {
                if (element.querySelector('.block--portfolio--arrow')) {
                    element.querySelector('.block--portfolio--arrow').remove();
                }
                if (element.querySelector('.block--gallery--arrow')) {
                    element.querySelector('.block--gallery--arrow').remove();
                }
            }

        }, 1000);

    });

    ///////// PREHOME

    const prehome = document.querySelector(".prehome");
    const websiteUrl = window.location.href;

    if (typeof(prehome) != 'undefined' && prehome != null) {

        if (websiteUrl.includes("#")) {
            prehome.style.setProperty("display", "none");
        } else {
            setTimeout(function() {
                prehome.style.setProperty("opacity", "0");
                setTimeout(function() {
                    prehome.style.setProperty("display", "none");
                }, 500);
            }, 3000);
        }
    }

    /////// NEWSLETTER URL

    // const email = document.querySelector("#email");

    // if (typeof(email) != 'undefined' && email != null) {

    //     // function you can use:
    //     function getSecondPart(str) {
    //         return str.split('=')[1];
    //     }

    //     email.value = getSecondPart(websiteUrl.replace('%40', '@'));

    // }

    ///////// ROUNDED IMGs

    const img = document.querySelectorAll(".borderRand img");

    function getRandomArbitrary(min, max) {
        return Math.floor(Math.random() * (max - min) + min);
    }

    function roundedImg() {
        img.forEach(element => {

            const corners = [];

            for (var i = 0; i < 4; i++) {
                const randomSeed = getRandomArbitrary(0, 2);
                if (randomSeed == 1) {
                    corners[i] = 25;
                } else {
                    corners[i] = 0;
                }
            }

            element.style.setProperty("border-radius", "" + corners[0] + "px " + "" + corners[1] + "px " + corners[2] + "px " + corners[3] + "px ");
        });
    }

    if (typeof(img) != 'undefined' && img != null) {
        roundedImg()
    }


    ///////// ROUNDED Buttons

    const buttons = document.querySelectorAll(".wp-block-file");

    function roundedBtn() {
        buttons.forEach(element => {

            const corners = [];

            for (var i = 0; i < 4; i++) {
                const randomSeed = getRandomArbitrary(0, 2);
                if (randomSeed == 1) {
                    corners[i] = 25;
                } else {
                    corners[i] = 0;
                }
            }
            for (var i = 4; i < 8; i++) {
                if (corners[i - 4] == 0) {
                    corners[i] = 25;
                } else {
                    corners[i] = 0;
                }
            }

            element.style.setProperty("border-radius", "" + corners[0] + "px " + "" + corners[1] + "px " + corners[2] + "px " + corners[3] + "px ");

            element.addEventListener("mouseenter", function() {
                element.style.setProperty("border-radius", "" + corners[4] + "px " + "" + corners[5] + "px " + corners[6] + "px " + corners[7] + "px ");
            });
            element.addEventListener("mouseleave", function() {
                element.style.setProperty("border-radius", "" + corners[0] + "px " + "" + corners[1] + "px " + corners[2] + "px " + corners[3] + "px ");
            });
        });
    }

    if (typeof(buttons) != 'undefined' && buttons != null) {
        roundedBtn()
    }

});

///////// CLEAN LSEP CHARACTER

window.onload = function() {
    const nsButton = document.querySelector(".newsletter--button");
    nsButton.innerHTML = nsButton.innerHTML.replace(/\u2028/g, '');
}